import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityOffRoundedIcon from "@material-ui/icons/VisibilityOffRounded";
import VisibilityRoundedIcon from "@material-ui/icons/VisibilityRounded";
import React from "react";

const customStyles = makeStyles({
  root: { marginBottom: "0px" },
  label: { fontSize: "13px" },
});

export default ({ allColumns }) => {
  const styles = customStyles();

  return (
    <Paper elevation={1} style={{ padding: "0px 15px" }}>
      <FormControl aria-label="Mostrar/Ocultar colunas" size="small" fullWidth>
        <FormGroup row className="q-center-toggler">
          {allColumns.map((column, index) => {
            if (column.toggable) {
              return (
                <FormControlLabel
                  key={index}
                  classes={{ label: styles.label, root: styles.root }}
                  label={column.Header}
                  control={
                    <Checkbox
                      checked={column.isVisible}
                      color="primary"
                      checkedIcon={<VisibilityRoundedIcon />}
                      icon={<VisibilityOffRoundedIcon />}
                      id={column.id}
                      {...column.getToggleHiddenProps()}
                    />
                  }
                />
              );
            }
          })}
        </FormGroup>
      </FormControl>
    </Paper>
  );
};
